// @ts-nocheck
import { RequestTrailerPickupResponseModel } from "@store/Framework/Types/ApiModels";
import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
} from "@toolkit/Modules/client-framework/HandlerCreator";
import { ServiceResult } from "@insite/client-framework/Services/ApiService";
import { postRequestTrailerPickup, RequestTrailerPickupApiParameter } from "@store/Framework/Services/TrailerServiceV2";

type ApiResult = RequestTrailerPickupResponseModel;
type ApiParameter = RequestTrailerPickupApiParameter;
type Parameter = ApiParameter & HasOnSuccess<ApiResult> & HasOnError<string>;

type HandlerType = ApiHandlerDiscreteParameter<Parameter, ApiParameter, ServiceResult<ApiResult>>;

export const PopulateApiParameter: HandlerType = props => {
    const { onSuccess, onError, ...apiParameter } = props.parameter;
    props.apiParameter = apiParameter;
};

export const PostDataToApi: HandlerType = async props => {
    props.apiResult = await postRequestTrailerPickup(props.apiParameter);
};

export const DispatchAddPickupRequest: HandlerType = async props => {
    if (props.apiResult.successful && props.apiResult.result.dropTrailerPickupRequest) {
        props.dispatch({
            type: "Greif/Pages/TrailerTrackingV2/AddPickupRequest",
            trailerPickupRequest: props.apiResult.result.dropTrailerPickupRequest,
        });
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (props.apiResult.successful) {
        props.parameter.onSuccess?.(props.apiResult.result);
    }
};

export const ExecuteOnErrorCallback: HandlerType = props => {
    if (!props.apiResult.successful) {
        props.parameter.onError?.(props.apiResult.errorMessage);
    }
};

export const chain = [
    PopulateApiParameter,
    PostDataToApi,
    DispatchAddPickupRequest,
    ExecuteOnSuccessCallback,
    ExecuteOnErrorCallback,
];

const requestTrailerPickup = createHandlerChainRunner(chain, "RequestTrailerPickup");
export default requestTrailerPickup;
